import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

export const selectMfa = createKeySelector('mfa');

export const getIsReauthing = createSelector(selectMfa, (mfa) => mfa.isReauthing);

export const getIsAuthOutage = createSelector(selectMfa, (mfa) => mfa.isOutage);

export const getRefreshToken = createSelector(selectMfa, (mfa) => mfa.refreshToken);

export const getOnboardingToken = createSelector(selectMfa, (mfa) => mfa.onboardingToken);

export const getOnboardingUserId = createSelector(selectMfa, (mfa) => mfa.onboardingUserId);

export const getAuthToken = createSelector(selectMfa, (mfa) => mfa.authToken);

export const getAppealToken = createSelector(selectMfa, (mfa) => mfa.appealToken);

export const getSelfieChallengeToken = createSelector(selectMfa, (mfa) => mfa.selfieChallengeToken);

export const getSelfieChallengeV2Status = createSelector(selectMfa, (mfa) => mfa.selfieStatus);

export const getAuthTokenExpiration = createSelector(selectMfa, (mfa) => mfa.authTokenExpiration);

export const getLoginType = createSelector(selectMfa, (mfa) => mfa.loginType);

export const getLoginError = createSelector(selectMfa, (mfa) => mfa.loginError);

export const getSmsCaptchaToken = createSelector(selectMfa, (mfa) => mfa.smsCaptchaToken);

export const getCaptchaType = createSelector(selectMfa, (mfa) => mfa.captchaType);

export const getAuthFunnelSessionId = createSelector(selectMfa, (mfa) => mfa.funnelSessionId);

export const getCaptchaKey = createSelector(selectMfa, (mfa) => mfa.captchaKey);

export const getIsGuestAuth = createSelector(selectMfa, (mfa) => mfa.isGuestAuth);

export const getGuestAuthToken = createSelector(selectMfa, (mfa) => mfa.guestAuthToken);

export const getMagicLinkType = createSelector(selectMfa, (mfa) => mfa.magicLinkType);
